import { jsx as _jsx } from "react/jsx-runtime";
const SIZE_MAP = {
    display: {
        size: "var(--hydrax-type-display-size)",
        lineHeight: "var(--hydrax-type-display-line-height)",
        weight: "var(--hydrax-type-display-weight)",
    },
    h1: {
        size: "var(--hydrax-type-h1-size)",
        lineHeight: "var(--hydrax-type-h1-line-height)",
        weight: "var(--hydrax-type-h1-weight)",
    },
    h2: {
        size: "var(--hydrax-type-h2-size)",
        lineHeight: "var(--hydrax-type-h2-line-height)",
        weight: "var(--hydrax-type-h2-weight)",
    },
};
export function Heading({ level = "h1", as, style, ...rest }) {
    const Tag = as ?? (level === "display" ? "h1" : level);
    const tokens = SIZE_MAP[level];
    return (_jsx(Tag, { style: {
            margin: 0,
            fontFamily: "var(--hydrax-font-sans)",
            fontSize: tokens.size,
            lineHeight: tokens.lineHeight,
            fontWeight: tokens.weight,
            color: "var(--hydrax-color-text-strong)",
            letterSpacing: "-0.01em",
            ...style,
        }, ...rest }));
}
//# sourceMappingURL=Heading.js.map